import { toast } from "react-toastify";
const toastOptions = {
    position: "top-left",
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    autoClose: 9000,
};
export const showError = (message) => {
    toast.error(message, toastOptions);
};
